import { render, staticRenderFns } from "./DateTimeLabel.vue?vue&type=template&id=58cc62c0&scoped=true&"
import script from "./DateTimeLabel.vue?vue&type=script&lang=ts&"
export * from "./DateTimeLabel.vue?vue&type=script&lang=ts&"
import style0 from "./DateTimeLabel.vue?vue&type=style&index=0&id=58cc62c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cc62c0",
  null
  
)

export default component.exports